import React, { useEffect } from 'react';
import { Form, Input, message, InputNumber, Select, Button } from 'antd';
import InputRules from '../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';

const layout = {
	labelCol: {
		span: 10,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 10,
		span: 16,
	},
};

const PackageEditForm = ({ fetchPackages, pkg, services, updatePackage, closeModal, fetchPackageServices }) => {
	useEffect(() => {
		fetchPackageServices();
	}, []);

	const onFinish = async (values) => {
		await updatePackage(pkg._id, values.pkg);
		fetchPackages();
		closeModal();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	return (
		<Form
			{...layout}
			name="PackageEditForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item
				initialValue={pkg?.name}
				label="Name"
				name={['pkg', 'name']}
				rules={InputRules.required('Please enter name!')}
			>
				<Input placeholder="Enter package name" />
			</Form.Item>
			{/* <Form.Item
				initialValue={pkg?.description}
				label="Description"
				name={['pkg', 'description']}
				rules={InputRules.required('Please enter package description!')}
			>
				<Input placeholder="Enter package description" />
			</Form.Item> */}
			<Form.Item
				initialValue={pkg?.price}
				label="Price"
				name={['pkg', 'price']}
				rules={InputRules.required('Please enter Price!')}
			>
				<InputNumber placeholder="Enter price for package" />
			</Form.Item>

			{/* <Form.Item
				initialValue={pkg?.discount}
				label="Discount"
				name={['pkg', 'discount']}
				rules={InputRules.required('Please enter discount')}
			>
				<InputNumber placeholder="Enter discount rate" />
			</Form.Item> */}

			{/* <Form.Item
				initialValue={pkg?.serviceType}
				label="Service Type"
				name={['pkg', 'serviceType']}
				rules={InputRules.required('Please service type!')}
			>
				<Input placeholder="Enter Service Type" />
			</Form.Item> */}

			<Form.Item
				initialValue={pkg?.perks}
				label="Key Points"
				name={['pkg', 'perks']}
				rules={InputRules.required('Please select key points!')}
			>
				<Select showSearch allowClear={true} placeholder="Select key points" mode="tags">
					<Select.Option></Select.Option>
				</Select>
			</Form.Item>

			<Form.Item
				initialValue={[pkg?.services[0]?._id]}
				label="Services"
				name={['pkg', 'services']}
				rules={InputRules.required('Please select services!')}
			>
				<Select showSearch allowClear={true} placeholder="Select services" mode="tags">
					{services.map((service) => {
						return (
							<Select.Option value={service?._id} key={service?._id}>
								{service?.id}
							</Select.Option>
						);
					})}
				</Select>
			</Form.Item>
			<Form.Item
				initialValue={pkg?.primaryActionText}
				label="Primary Button Label"
				name={['primaryActionText']}
				rules={InputRules.required('Please enter label for primary button!')}
			>
				<Input placeholder="Enter primary action label" />
			</Form.Item>
			<Form.Item
				initialValue={pkg?.primaryActionHref}
				label="Primary Button Link"
				name={['primaryActionHref']}
				rules={InputRules.required('Please enter href for primary button!')}
			>
				<Input placeholder="Enter primary action href" />
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Update Package
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({
	services: store.service.services,
});

const mapDispatchToProps = (dispatch) => ({
	fetchPackageServices: () => dispatch(Actions.fetchPackageServices()),
	fetchPackages: () => dispatch(Actions.fetchPackages()),
	updatePackage: (id, body) => dispatch(Actions.updatePackage(id, body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PackageEditForm);
